import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pagination-small',
  templateUrl: './pagination-small.component.html',
  styleUrls: ['./pagination-small.component.scss']
})
export class PaginationSmallComponent implements OnInit {

  @Input('data') data;
  @Input('itemsPerPage') itemsPerPage = 10;
  @Output() outputData: EventEmitter<Object> = new EventEmitter<Object>();
  // public itemsPerPage: number;
  public totalItems: any;
  public page: any;
  public previousPage: any;
  private paginatedData: any;

  constructor() { }

  ngOnInit() {
    this.totalItems = this.data.length;
    this.page = 1;
  }

  public loadPage(page: number): void {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.loadData();
    }
  }

  private loadData(): void {
    this.paginatedData = this.data.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
    this.outputData.emit(this.paginatedData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination-small/pagination-small.component.ts